<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import "~material-design-icons-iconfont/dist/material-design-icons.css";
@import "~vuetify/dist/vuetify.min.css";

.v-toolbar__content {
  .v-input__slot {
    /* Fix inputs in the toolbar from having a bottom margin. */
    margin-bottom: 0;
  }
}

/*
   Make v-autocomplete match the text field's width no matter how long the item gets.
   There's a min-width inline style applied by vuetify, that's why this works.
   For reference: https://github.com/vuetifyjs/vuetify/issues/4901
 */
.v-autocomplete__content {
  max-width: 0px;
}

/* Hide ugly spinner icon from date input field */
input[type="date"]::-webkit-inner-spin-button {
  display: none;
  -webkit-appearance: none;
}

table.v-table thead th,
table.v-table tbody td {
  font-size: 16px;
}
</style>
